module.exports = __webpack_public_path__ + "img/3-3.2a3ba36.jpg";